import { AccountEvents, AccountSwitchCompletedPayload } from '@goto/shell'
import { LaunchDarklyPayload } from '../models/feature-flag.models'
import { getValueFromLocalStorage, onWindowUnload, reloadPage } from './dom-helpers'

export const getLaunchDarklyFlag = <U extends keyof T, T = LaunchDarklyPayload>(flag: U) =>
  globalThis.shell.featureFlags?.getLaunchDarklyFlag<U, T>(flag)

export const getFeatureFlag = <T>(key: string, defaultValue: T): T =>
  globalThis.shell.featureFlags?.getFeatureFlagValue<T>(key, defaultValue) ?? defaultValue

export const initAccountSwitch = () => {
  const { accountSwitchCompleted } = window.shell.eventBus.subscribeTo<'account', typeof AccountEvents>('account')

  const accountSwitchCompletedListener = (payload: AccountSwitchCompletedPayload) => {
    const { externalUserKey, pbxId } = payload
    const localStorageKey = `jiveweb_userSelectedDevice_${externalUserKey}`
    const localStorageSelectedUser = getValueFromLocalStorage(localStorageKey)
    // Jiveweb reloads after 100ms, we should wait a bit longer to allow for that reload to occur first
    setTimeout(() => {
      if (localStorageSelectedUser?.pbx?.id !== pbxId) {
        localStorage.removeItem(localStorageKey)
      }
      reloadPage()
    }, 150)
  }

  accountSwitchCompleted.on(accountSwitchCompletedListener)

  onWindowUnload(() => {
    accountSwitchCompleted.removeListener(accountSwitchCompletedListener)
  })
}
